var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-path filter",
    fill: "#000",
    d: "M13.938 1.223c7.02 0 12.732 5.71 12.732 12.732 0 7.02-5.712 12.734-12.732 12.734-7.021 0-12.733-5.713-12.733-12.734S6.917 1.223 13.938 1.223zm0-1.159C6.266.064.047 6.284.047 13.954c0 7.672 6.22 13.891 13.89 13.891 7.672 0 13.89-6.219 13.89-13.89 0-7.672-6.218-13.89-13.89-13.89zm-1.159 22.573a.58.58 0 0 1-.577-.58v-7.83L5.464 8.611a.58.58 0 0 1 .37-1.024H22.04a.58.58 0 0 1 .37 1.024l-6.737 5.614v6.096a.577.577 0 0 1-.231.462l-2.315 1.738a.579.579 0 0 1-.348.115zM7.433 8.747l5.717 4.763a.581.581 0 0 1 .208.445V20.9l1.159-.868v-6.078c0-.172.076-.334.208-.445l5.717-4.764H7.433z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.94f02474154f7004fab2dd25729f6e1c.svg";
export { ForwardRef as ReactComponent };